import React from 'react';
import SimplePage from '../../layout/SimplePage/SimplePage';
import Container from '../../layout/Container/Container';
import StandaloneContractsSign from './components/StandaloneContractsSign';

const ContractsPage = () => {
  return (
    <SimplePage>
      <Container>
        <StandaloneContractsSign />
      </Container>
    </SimplePage>
  );
};

export default ContractsPage;
